// import bootstrap
import * as bootstrap from "bootstrap";

var lastTextArea = null;
var lastCursorPosition = null;
var activeIndex = 0;

// Store where in the textarea the cursor is
function getCursorPosition(textarea) {
  var cursorPosition = textarea.selectionStart;
  return cursorPosition;
}

// Create a function to insert text at the cursor position
function insertTextAtCursor(textarea, text, position) {
  var value = textarea.value;
  var newValue =
    value.substring(0, position) + text + value.substring(position);
  textarea.value = newValue;

  //  Reeturn the new cursor position
  return position + text.length;
}

// Handle when a template is clicked
function handleTemplateSelected(item) {
  var text = item.dataset.text;

  var cursorPos = insertTextAtCursor(lastTextArea, text, lastCursorPosition);

  // Hide the modal
  var modalElement = document.getElementById("search-text-templates-modal");
  var searchModal = bootstrap.Modal.getInstance(modalElement);
  searchModal.hide();

  // change event to trigger the htmx request
  lastTextArea.dispatchEvent(new Event("change"));

  lastTextArea.focus();
  lastTextArea.setSelectionRange(cursorPos, cursorPos);
}

// Set the active item
function setActiveItem(items, index) {
  items.forEach(function (item, i) {
    if (i === index) {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });
}

var itemClickedHandler = function (event) {
  event.preventDefault();
  handleTemplateSelected(this);
};

//   Add event listeners
document.addEventListener("DOMContentLoaded", function () {
  const modalElement = document.getElementById("search-text-templates-modal");
  var searchModal = new bootstrap.Modal(modalElement);

  document.querySelectorAll("textarea").forEach(function (textarea) {
    textarea.addEventListener("keydown", function (event) {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        lastTextArea = textarea;
        lastCursorPosition = getCursorPosition(textarea);
        searchModal.show();
      }
    });
  });

  // Make the search input focused when the modal is shown
  modalElement.addEventListener("shown.bs.modal", function () {
    document.getElementById("text-template-search").focus();
  });

  // Set the active item on hover
  modalElement.addEventListener("mouseover", function (event) {
    if (event.target.classList.contains("text-template-list-item")) {
      var items = Array.from(
        document.querySelectorAll(".text-template-list-item")
      );
      var activeIndex = items.indexOf(event.target);
      setActiveItem(items, activeIndex);
    }
  });

  modalElement.addEventListener("keydown", function (event) {
    var items = Array.from(
      document.querySelectorAll(".text-template-list-item")
    );

    if (event.key === "ArrowUp") {
      event.preventDefault();
      if (activeIndex > 0) {
        activeIndex--;
      }
      setActiveItem(items, activeIndex);
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      if (activeIndex < items.length - 1) {
        activeIndex++;
        console.log(activeIndex);
      }
      setActiveItem(items, activeIndex);
    } else if (event.key === "Enter") {
      event.preventDefault();
      handleTemplateSelected(items[activeIndex]);
    }

    setActiveItem(items, activeIndex);
  });

  document.addEventListener("htmx:afterOnLoad", function () {
    console.log("htmx:afterOnLoad");
    document
      .querySelectorAll(".text-template-list-item")
      .forEach(function (item) {
        item.addEventListener("click", itemClickedHandler);
      });
  });
});
